<template>
  <v-container fluid grid-list-md>
    <v-card class="mb-2">
      <v-card-title>
        <span class="headline mb-0">倉庫別コンテナ受入枠詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()" v-if="!$route.query.id" :disabled="!valid">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-form>
      <v-layout row style="margin-top: 24px !important" wrap>
        <v-flex md6 sm12 style="padding: 0px !important; padding-right: 10px">
          <v-card>
            <v-card-text>
              <v-container fluid style="padding: 17px !important">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-checkbox
                      :disabled="operating === 'EDIT'"
                      v-model="isSJL"
                      label="SJL"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12>
                    <remote-autocomplete
                      :disabled="operating === 'EDIT'"
                      label="納入場所"
                      url="warehouses/kv"
                      v-model="settings.warehouseId"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <remote-autocomplete
                      v-if="isSJL"
                      label="所属会社"
                      url="companies/kv"
                      v-model="companyId"
                      :disabled="true"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <remote-autocomplete
                      :disabled="operating === 'EDIT'"
                      v-if="!isSJL"
                      label="事業本部"
                      url="divisions/kv?type=BU"
                      v-model="settings.buId"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <remote-autocomplete
                      ref="businessUnit"
                      :disabled="operating === 'EDIT'"
                      v-if="!isSJL"
                      label="ビジネスユニット"
                      :url="
                        `divisions/kv?type=BUSINESS_UNIT&buId=${settings.buId}`
                      "
                      v-model="settings.businessUnitId"
                    ></remote-autocomplete>
                  </v-flex>
                  <!-- <v-flex>
                    <remote-autocomplete
                      ref="productGroup"
                      v-if="!isSJL"
                      label="品種グループ"
                      clearable
                      :url="`/product-groups/kv?buId=${settings.buId}&businessUnitId=${settings.businessUnitId}`"
                      v-model="settings.productGroup"
                    >
                    </remote-autocomplete>
                  </v-flex> -->
                  <v-flex>
                    品種グループ
                    <v-radio-group v-model="settings.productGroup">
                      <v-radio
                        v-for="n in productGroups"
                        :key="n.value"
                        :label="n.value"
                        :value="n.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 sm12 style="padding: 0px !important; padding-right: 10px">
          <v-card
            v-for="productGroup in settings.productGroups"
            :key="productGroup.name"
            v-show="settings.productGroup === productGroup.name"
          >
            <v-container fluid style="padding: 17px !important">
              <v-layout row wrap>
                <v-flex xs12>
                  <calendar
                    @refresh="refresh"
                    class="mt-2"
                    :operating="operating"
                    :settings="settings"
                    :type="productGroup.name"
                    :isSJL="isSJL"
                    :companyId="companyId"
                    v-model="productGroup.dailySettings"
                    :ref="productGroup.name"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import Calendar from './Calendar'

/* eslint-disable no-console */
export default {
  components: { Calendar },

  data() {
    return {
      isSJL: false,
      operating: 'NEW',
      resultList: [],
      newList: [],
      editList: [],
      companyId: '',
      settings: {
        productGroups: [],
      },
      productGroups: [],
    }
  },
  methods: {
    loadSJL() {
      this.$http.get(`companies/find-by-code/SJL`).then((res) => {
        this.companyId = res.data.companyId
      })
    },
    loadProductGroups() {
      this.$http
        .get(
          `/product-groups/kv?buId=${this.settings.buId}&businessUnitId=${
            this.settings.businessUnitId ? this.settings.businessUnitId : ''
          }`
        )
        .then((res) => {
          this.productGroups = res.data
        })
    },
    dealData() {
      this.settings.productGroups
        .filter((p) => p != null)
        .filter((p) => p.dailySettings != null)
        .filter((p) => p.dailySettings.length > 0)
        .forEach((p) => {
          p.dailySettings
            .filter((d) => d.upperLimit !== null)
            .filter((d) => d.upperLimit !== '')
            .forEach((dailySetting) => {
              var warehouseContainerSetting = {}
              if (!this.isSJL) {
                warehouseContainerSetting = {
                  id: dailySetting.id,
                  warehouseId: this.settings.warehouseId,
                  buId: this.settings.buId,
                  businessUnitId: this.settings.businessUnitId,
                  productGroupName: p.name,
                  date: dailySetting.date,
                  upperLimit: dailySetting.upperLimit,
                }
              } else {
                warehouseContainerSetting = {
                  id: dailySetting.id,
                  warehouseId: this.settings.warehouseId,
                  buId: this.companyId,
                  businessUnitId: null,
                  productGroupName: null,
                  date: dailySetting.date,
                  upperLimit: dailySetting.upperLimit,
                }
              }

              if (!dailySetting.id) {
                this.newList.push(warehouseContainerSetting)
              } else {
                this.editList.push(warehouseContainerSetting)
              }
            })
        })
    },
    save() {
      this.dealData()
      this.$http
        .post(`/warehouse-container-settings`, this.newList)
        .then((res) => {
          var errors = []
          res.data
            .filter((r) => !r.success)
            .forEach((r) => {
              if (errors.indexOf(r.localeMessage) === -1) {
                errors.push(r.localeMessage)
              }
            })
          if (errors.length === 0) {
            this.$message('', '保存しました。')
          } else {
            var errMsg = errors.join(',')
            this.$message('', errMsg)
          }
          this.$router.push('/M0290')
        })
        .catch((err) => {
          // console.log(err.response.data.message)
          this.$message('', err.response.data.message || '保存できません。')
          this.$router.push('/M0290')
        })
    },
    refresh() {},
  },
  watch: {
    'settings.buId'() {
      if (!this.isSJL && this.operating === 'NEW') {
        if (!this.settings.buId) {
          this.settings.businessUnitId = null
          this.settings.productGroup = null
          this.settings.productGroups = []
          this.$refs.businessUnit.items = []
          this.$refs.productGroup.items = []
          this.productGroups = []
        }
        this.loadProductGroups()
        this.$forceUpdate()
      }
    },
    'settings.businessUnitId'() {
      if (!this.isSJL && this.operating === 'NEW') {
        if (!this.settings.businessUnitId) {
          this.settings.productGroup = null
          this.settings.productGroups = []
          this.$refs.productGroup.items = []
          this.productGroups = []
        }
        this.loadProductGroups()
        this.$forceUpdate()
      }
    },
    'settings.productGroup'() {
      if (this.settings.buId) {
        var p = this.settings.productGroups.find(
          (p) => p.name === this.settings.productGroup
        )
        if (!p) {
          this.settings.productGroups.push({ name: this.settings.productGroup })
        }
      }
    },
    isSJL() {
      this.settings.productGroups = []
      if (this.operating === 'NEW' && this.isSJL) {
        this.settings.productGroup = 'SJL'
        if (this.settings.productGroups.length === 0) {
          this.settings.productGroups.push({ name: 'SJL' })
        }
      }
    },
  },
  mounted() {
    this.loadSJL()
  },
  computed: {
    valid() {
      if (this.isSJL) {
        return (
          this.settings.warehouseId &&
          this.settings.productGroups.filter(
            (s) => s.dailySettings && s.dailySettings.length > 0
          ).length > 0
        )
      }
      return (
        this.settings.warehouseId &&
        this.settings.buId &&
        this.settings.productGroups.filter(
          (s) => s.dailySettings && s.dailySettings.length > 0
        ).length > 0
      )
    },
  },
}
</script>
<style scoped>
.v-card:not(:first-child) {
  margin-top: 0px !important;
}
</style>
